import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { UPDATE_DATA_RETENTION_SETTINGS } from './actionTypes';
import { updateDataRetentionSettingsSuccess, updateDataRetentionSettingsError } from './actions';
import { getDataRetentionAPI } from '../../../api/dataRetention';

const dataRetentionAPI = getDataRetentionAPI();

function* updateDataRetentionSettings({ payload: { user, fields } }) {
  try {
    const response = yield call(dataRetentionAPI.updateSettings, user.token, fields);
    yield put(updateDataRetentionSettingsSuccess(response.message));
  } catch (error) {
    yield put(updateDataRetentionSettingsError(error));
  }
}

export function* watchUpdateDataRetentionSettings() {
  yield takeEvery(UPDATE_DATA_RETENTION_SETTINGS, updateDataRetentionSettings);
}

function* updateDataRetentionSettingsSaga() {
  yield all([fork(watchUpdateDataRetentionSettings)]);
}

export default updateDataRetentionSettingsSaga;
